module.exports = __webpack_public_path__ + "static/media/6.d88949c3.jpg";